import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { LanguageProvider } from '@/context/LanguageContext';
import Header from '@/components/site/Header';
import Hero from '@/components/site/Hero';
import Problem from '@/components/site/Problem';
import Solution from '@/components/site/Solution';
import Services from '@/components/site/Services';
import Advantages from '@/components/site/Advantages';
import Approach from '@/components/site/Approach';
import Process from '@/components/site/Process';
import Audience from '@/components/site/Audience';
import Stats from '@/components/site/Stats';
import Testimonials from '@/components/site/Testimonials';
import FAQ from '@/components/site/FAQ';
import Contact from '@/components/site/Contact';
import Footer from '@/components/site/Footer';
import CookieBanner from '@/components/site/CookieBanner';
import PrivacyPage from '@/pages/PrivacyPage';

const Site = () => (
  <>
    <Header />
    <main>
      <Hero />
      <Problem />
      <Solution />
      <Services />
      <Advantages />
      <Approach />
      <Process />
      <Audience />
      <Stats />
      <Testimonials />
      <FAQ />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Site />} />
            <Route path="/confidentialite" element={<PrivacyPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
        <Toaster
          position="top-right"
          theme="light"
          richColors
          closeButton
        />
      </LanguageProvider>
    </div>
  );
}

export default App;
